import { RUBRIQ_ZONKA_SURVEY_LINKS, RUBRIQ_ZONKA_SURVEY_PREVIEW_LINKS, ZONKA_FORM_ID, ZONKA_SCRIPT_ID, ZONKA_NONPROD_SCRIPT_SRC, ZONKA_NONPROD_FORM_ID } from 'rubriq/constants';
import { environment } from 'shared/helper/environment';

/* eslint-disable no-underscore-dangle */

var ZONKA_VARIABLES_SETTLE_DELAY_MS = 100;
function queueZonkaCall() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  window._zfQueue.push(args);
}
export var loadZonkaScript = function loadZonkaScript() {
  return new Promise(function (resolve) {
    window._zfQueue = window._zfQueue || [];
    window._zf = window._zf || function zonkaQueue() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      window._zfQueue.push(args);
    };
    var existingScript = document.getElementById(ZONKA_SCRIPT_ID);
    if (existingScript) {
      resolve();
      return;
    }
    var isProduction = environment() === 'production';
    var src = isProduction ? RUBRIQ_ZONKA_SURVEY_LINKS.default : RUBRIQ_ZONKA_SURVEY_PREVIEW_LINKS.default;
    var SCRIPT_SRC = isProduction ? ZONKA_SCRIPT_ID : ZONKA_NONPROD_SCRIPT_SRC;
    var script = document.createElement('script');
    script.async = true;
    script.id = SCRIPT_SRC;
    script.src = src;
    script.onload = resolve;
    script.onerror = resolve;
    document.head.appendChild(script);
  });
};
export var triggerZonkaSurvey = function triggerZonkaSurvey(_ref) {
  var language = _ref.language,
    variables = _ref.variables,
    formId = _ref.formId,
    nonProdFormId = _ref.nonProdFormId;
  if (typeof window._zf !== 'function') return;
  window._zf('variables', variables);
  setTimeout(function () {
    var isProduction = environment() === 'production';
    var src = isProduction ? formId !== null && formId !== void 0 ? formId : ZONKA_FORM_ID : nonProdFormId !== null && nonProdFormId !== void 0 ? nonProdFormId : ZONKA_NONPROD_FORM_ID;
    window._zf('startForm', src);
  }, ZONKA_VARIABLES_SETTLE_DELAY_MS);
};

/* eslint-enable no-underscore-dangle */